import { useNavigate } from "react-router";
import { AlertCircle } from "lucide-react";

import PageWrapper from "@/components/layout/page-wrapper";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const PaymentCanceled = () => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate("/app/billing");
    };

    return (
        <PageWrapper pageTitle="Payment Canceled" currentPage="Payment Canceled">
            <div className="flex flex-col items-center justify-center h-full py-12">
                <Card className="bg-white p-8 max-w-md w-full mx-4 shadow-lg">
                    <div className="flex flex-col items-center justify-center">
                        <div className="bg-yellow-100 rounded-full p-4 mb-6">
                            <AlertCircle className="h-16 w-16 text-yellow-600" />
                        </div>
                        <h1 className="text-3xl font-bold text-gray-800 mb-4">Payment Canceled</h1>
                        <p className="text-gray-600 text-center max-w-sm mb-8">
                            Your payment process has been canceled. If you wish to proceed with your subscription,
                            please return to the billing page to initiate the payment again.
                        </p>
                        <Button onClick={handleNavigate} className="bg-yellow-600 hover:bg-yellow-700">
                            Return to Billing
                        </Button>
                    </div>
                </Card>
            </div>
        </PageWrapper>
    );
};

export default PaymentCanceled;